import { useEffect, useState } from "react";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import { Dropdown } from "../../shared/v1";

let cachedAgentPromise = null;

const ReassignModal = ({
  assignedToUserId,
  onClose,
  dropdownUpdater,
  reassignTasksHandler,
  selectedTasks,
  showReassignModal,
}) => {
  const [agentsOptions, setAgentsOptions] = useState([]);
  useEffect(() => {
    if (!cachedAgentPromise) {
      cachedAgentPromise = caseTransformingAxios.get("/simple_account_active_agents").then((response) =>
        [{ label: "Anyone", value: "anyone" }].concat(
          response.data.map((agent) => ({
            label: agent.fullName,
            value: agent.uuid,
            email: agent.email,
          })),
        ),
      );
    }
    cachedAgentPromise.then(setAgentsOptions);
  }, []);

  return (
    <Modal
      show={showReassignModal}
      onHide={onClose}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header
        title={`Do you really want to reassign ${selectedTasks.length} task${selectedTasks.length > 1 ? "s" : ""}?`}
        closeButton
      />

      <Modal.Body>
        <label>Assign these Tasks to</label>
        <Dropdown
          isSearchable={true}
          name="assigned_to_user_id"
          onUpdate={dropdownUpdater}
          isClearable={false}
          value={assignedToUserId}
          options={agentsOptions}
        />
      </Modal.Body>

      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
        <Button size="medium" schema="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button size="medium" onClick={reassignTasksHandler}>
          Reassign
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReassignModal;
